"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Color = void 0;

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * Color
 * 
 * all the colors used by paneka design system
 * 
 * @readonly
 * @enum {string}
 * 
 * @property {string} None
 * @property {string} Note
 * @property {string} NoteShade
 * @property {string} Trace
 * @property {string} Trace
 * @property {string} TraceTint1
 * @property {string} TraceTint2
 * @property {string} Rust
 * @property {string} RustShade
 * @property {string} RustTint1
 * @property {string} RustTint2
 * @property {string} Sky
 * @property {string} SkyShade
 * @property {string} SkyTint1
 * @property {string} SkyTint2
 * @property {string} Error
 * @property {string} ErrorShade
 * @property {string} ErrorTint1
 * @property {string} ErrorTint2
 * @property {string} Warning
 * @property {string} WarningShade
 * @property {string} WarningTint1
 * @property {string} WarningTint2
 * @property {string} Confirmed
 * @property {string} ConfirmedShade
 * @property {string} ConfirmedTint1
 * @property {string} ConfirmedTint2
 * @property {string} Black
 * @property {string} Grey1
 * @property {string} Grey2
 * @property {string} Grey3
 * @property {string} Grey4
 * @property {string} GreyTransparent
 * @property {string} White1
 * @property {string} White2
 * @property {string} DavidsFavorite
 * 
 * @category Atoms
 */
var Color = {
  /** no color specified */
  Transparent: 'transparent-color',
  None: '',
  Note: 'note-color',
  NoteShade: 'note-shade-color',
  Trace: 'trace-regular-color',
  TraceTint1: 'trace-tint1-color',
  TraceTint2: 'trace-tint2-color',
  TraceShade1: 'trace-shade-color',
  TraceShade2: 'trace-shade2-color',
  Rust: 'rust-color',
  RustShade: 'rust-shade-color',
  RustTint1: 'rust-tint1-color',
  RustTint2: 'rust-tint2-color',
  Sky: 'sky-color',
  SkyShade: 'sky-shade-color',
  SkyTint1: 'sky-tint1-color',
  SkyTint2: 'sky-tint2-color',
  Error: 'error-color',
  ErrorShade: 'error-shade-color',
  ErrorTint1: 'error-tint1-color',
  ErrorTint2: 'error-tint2-color',
  Warning: 'warning-color',
  WarningShade: 'warning-shade-color',
  WarningTint1: 'warning-tint1-color',
  WarningTint2: 'warning-tint2-color',
  Confirmed: 'confirmed-color',
  ConfirmedShade: 'confirmed-shade-color',
  ConfirmedTint1: 'confirmed-tint1-color',
  ConfirmedTint2: 'confirmed-tint2-color',
  Black: 'black-color',
  Grey1: 'grey1-color',
  Grey2: 'grey2-color',
  Grey3: 'grey3-color',
  Grey4: 'grey4-color',
  GreyTransparent: 'grey-transparent-color',
  White1: 'white1-color',
  White2: 'white2-color',
  DavidsFavorite: 'purple-color',

  /** Updated Brand Colors */
  Teal50: 'teal-50-color',
  Teal40: 'teal-40-color',
  Teal30: 'teal-30-color',
  Teal30Hover: 'teal-30-hover-color',
  Teal30Pressed: 'teal-30-pressed-color',
  Teal20: 'teal-20-color',
  Teal10: 'teal-10-color',
  Red50: 'red-50-color',
  Red40: 'red-40-color',
  Red40Hover: 'red-40-hover-color',
  Red40Pressed: 'red-40-pressed-color',
  Red30: 'red-30-color',
  Red20: 'red-20-color',
  Red10: 'red-10-color',
  Yellow50: 'yellow-50-color',
  Yellow40: 'yellow-40-color',
  Yellow40Hover: 'yellow-40-hover-color',
  Yellow40Pressed: 'yellow-40-pressed-color',
  Yellow30: 'yellow-30-color',
  Yellow20: 'yellow-20-color',
  Yellow10: 'yellow-10-color',
  GreenTint: 'green-tint-color',
  GreenTintHover: 'green-tint-hover-color',
  GreenTintPressed: 'green-tint-pressed-color',
  BlueTint: 'blue-tint-color',
  BlueTintHover: 'blue-tint-hover-color',
  BlueTintPressed: 'blue-tint-pressed-color',
  Charcoal50: 'charcoal-50-color',
  Charcoal40: 'charcoal-40-color',
  Charcoal30: 'charcoal-30-color',
  Charcoal20: 'charcoal-20-color',
  Charcoal10: 'charcoal-10-color',
  Charcoal10Hover: 'charcoal-10-hover-color',
  Charcoal10Pressed: 'charcoal-10-pressed-color',
  Charcoal1: 'charcoal-1-color',
  Charcoal1Hover: 'charcoal-1-hover-color',
  Charcoal1Pressed: 'charcoal-1-pressed-color',
  Charcoal50Transparent75: 'charcoal-50-transparent-75-color',
  Charcoal50Transparent50: 'charcoal-50-transparent-50-color',
  Charcoal50Transparent25: 'charcoal-50-transparent-25-color',
  Sand: 'sand-color',
  White: 'white-color',
  WhiteHover: 'white-hover-color',
  WhitePressed: 'white-pressed-color',
  WhiteTransparent90: 'white-transparent-90-color',
  WhiteTransparent75: 'white-transparent-75-color',
  WhiteTransparent50: 'white-transparent-50-color',
  WhiteTransparent25: 'white-transparent-25-color'
  /* End updated brand colors */

};
exports.Color = Color;